// extracted by mini-css-extract-plugin
module.exports = {"root":"u-flowable-checkbox_edit_2k0eE_7X"};